// import logoLabeler from '@Cyclope-Assets/images/logo/tunnelwatch.png';

import * as React from "react";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-router-dom
   * @infos "https://reactjs.org"
   */
  return (
    <div className="maintenance animated fadeIn">
      <div className="ml_maintenance">
        <div className="ml_clearRoad">
          <div className="modale-loader-cyclope animated fadeOut delay-1m">
            <div className="lds-spinner">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
          <div className="message-empty-incident animated fadeOut delay-1m">
            <p>{i18next.t("veuillez patienter quelques instants")}</p>
          </div>
          <div className="message-empty-incident animated fadeIn delay-1m">
            <p> {i18next.t("message unique des erreurs")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onAddInhibition?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/virtual-loader/component.tsx